import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";

export class LineupsMemberSuspensionViewModel extends BaseViewModel {}
